import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/measurement-unit/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const measurementUnit = {
  get: apiPathFunc(pathBase),
} as const;
